import { render, staticRenderFns } from "./lokasifa.vue?vue&type=template&id=0ada8246"
import script from "./lokasifa.vue?vue&type=script&lang=js"
export * from "./lokasifa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports